const shader = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform vec4 filterArea;
uniform vec4 filterClamp;
uniform vec2 dimensions;

uniform bool enableLeftPart;  
uniform bool enableRightPart; 
uniform bool enableTopPart; 
uniform bool enableBottomPart;

void main(void)
{
    // Normalize coordinates using filterArea and dimensions for cross-browser compatibility
    vec2 pixelCoord = vTextureCoord.xy * filterArea.xy;
    vec2 normalizedCoord = pixelCoord / dimensions;
    
    vec2 uv = vTextureCoord;
    bool isRightHalf = normalizedCoord.x > 0.5;
    bool isBottomHalf = normalizedCoord.y > 0.5;

    // Apply horizontal mirroring
    if (isRightHalf && enableLeftPart) {
        // Mirror right half to left half
        float centerX = 0.5 * dimensions.x / filterArea.x;
        uv.x = centerX + centerX - vTextureCoord.x;
    } else if (!isRightHalf && enableRightPart) {
        // Mirror left half to right half
        float centerX = 0.5 * dimensions.x / filterArea.x;
        uv.x = centerX + centerX - vTextureCoord.x;
    }

    // Apply vertical mirroring
    if (isBottomHalf && enableTopPart) {
        // Mirror bottom half to top half
        float centerY = 0.5 * dimensions.y / filterArea.y;
        uv.y = centerY + centerY - vTextureCoord.y;
    } else if (!isBottomHalf && enableBottomPart) {
        // Mirror top half to bottom half
        float centerY = 0.5 * dimensions.y / filterArea.y;
        uv.y = centerY + centerY - vTextureCoord.y;
    }

    vec4 color = texture2D(uSampler, clamp(uv, filterClamp.xy, filterClamp.zw));
    gl_FragColor = color;
}
`;

exports.shader = shader;